import { useCallback, useState } from 'react'
import { FacebookAuthProvider, GoogleAuthProvider, OAuthProvider, signInWithPopup, signOut } from 'firebase/auth'
import { firebaseAuth, isFirebaseClientConfigured, getFirebaseAuth } from '../../../firebase/firebaseClient'
import authService from '../services/authService'

function assertFirebaseReady() {
  if (!isFirebaseClientConfigured()) {
    throw new Error(
      'Firebase is not configured. Set NEXT_PUBLIC_FIREBASE_API_KEY, NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN, NEXT_PUBLIC_FIREBASE_PROJECT_ID, and NEXT_PUBLIC_FIREBASE_APP_ID.'
    )
  }
  return getFirebaseAuth()
}

export function useFirebaseSocialAuth() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const exchange = useCallback(async (firebaseUser) => {
    const idToken = await firebaseUser.getIdToken(true)
    return await authService.firebaseLogin(idToken)
  }, [])

  const loginWithGoogle = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      assertFirebaseReady()
      const provider = new GoogleAuthProvider()
      provider.setCustomParameters({ prompt: 'select_account' })
      const result = await signInWithPopup(firebaseAuth, provider)
      return await exchange(result.user)
    } catch (e) {
      setError(e)
      throw e
    } finally {
      setLoading(false)
    }
  }, [exchange])

  const loginWithFacebook = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      assertFirebaseReady()
      const provider = new FacebookAuthProvider()
      const result = await signInWithPopup(firebaseAuth, provider)
      return await exchange(result.user)
    } catch (e) {
      setError(e)
      throw e
    } finally {
      setLoading(false)
    }
  }, [exchange])

  const loginWithApple = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      assertFirebaseReady()
      const provider = new OAuthProvider('apple.com')
      const result = await signInWithPopup(firebaseAuth, provider)
      return await exchange(result.user)
    } catch (e) {
      setError(e)
      throw e
    } finally {
      setLoading(false)
    }
  }, [exchange])

  const logoutFirebase = useCallback(async () => {
    if (!isFirebaseClientConfigured()) return
    await signOut(firebaseAuth)
  }, [])

  return {
    loading,
    error,
    loginWithGoogle,
    loginWithFacebook,
    loginWithApple,
    logoutFirebase,
  }
}
